import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("TextPanelWidget", {
  title: "Text Panel",
  attributes: {
    headline: {
      title: "Headline",
    },
  },
  properties: ["headline"],
  initialContent: {
    headline: "new panel",
  },
});
